import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RoleGuard = ({ children }: { children: React.ReactNode }) => {
  const role = useSelector((state: any) => state.security?.array?.role || '');

  if (role === 'Operator') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
